import { createFetchContext } from '@/modules/auto-fetch-contex'
import { expiringFanService } from '@/modules/expiring-fans/service/expiring-fans-service'

export const {
  useExpiringFanService,
  DefaultExpiringFansProvider,
  CustomExpiringFansProvider,
} = createFetchContext('ExpiringFans', { expiringFanService })
